import React from 'react'
import Drawer from '@material-ui/core/Drawer'
import CustomerView from '../Customer/CustomerView'
import ProductView from '../Products/ProductView'
import LogisticView from '../Logistic/LogisticView'
import BillingView from '../Billing/BillingView'
import SalesDrawer from '../Drawers/SalesDrawer'
import { connect } from 'react-redux';
import * as actionCreators from '../../actions/admin';
import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';


function mapStateToProps(state) {
    return {
      status: state.sales.currentView,
      openMenu: state.drawer.openMenu,

    };
  }

  function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
  }


@connect(mapStateToProps, mapDispatchToProps)
class SalesView extends React.Component {
    constructor(props){
        super(props)
        this.state = {
          openMenu: this.props.openMenu
        }
        this.getView = this.getView.bind(this)
    }

    getView(){

        let view = <BillingView />
        if(this.props.status == 'Productos'){
            view = <ProductView />
        }
        else if(this.props.status == 'Logistica'){
            view = <LogisticView />;
        }
        else if(this.props.status == 'Clientes'){
            view = <CustomerView />
        }
        return view;
    }
    clicked = (e) =>{
        this.props.switchMenu(false)
    }

    render() {
        const view = this.getView()
        return (
            <div>
                <Drawer
                    anchor="left"
                    open={this.props.openMenu}
                    onClick={this.clicked}
                >
                    <SalesDrawer/>
                </Drawer>
                <div className="col-md-11 col-md-offset-1">
                   {view}
                </div>
            </div>
        )
    }
}

export default SalesView



// WEBPACK FOOTER //
// ./src/components/Sales/SalesView.js